import { render, staticRenderFns } from "./leftTabs.vue?vue&type=template&id=c8fd0396&scoped=true"
import script from "./leftTabs.vue?vue&type=script&lang=js"
export * from "./leftTabs.vue?vue&type=script&lang=js"
import style0 from "./leftTabs.vue?vue&type=style&index=0&id=c8fd0396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fd0396",
  null
  
)

export default component.exports